import { defaultAbmsCertificationData } from '../../../../backend/config/classifiers/defaults/DefaultAbmsCertificationData';
import { abmsCertificationSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const abmsCertificationEntityName = 'abmsCertification';
const abmsCertificationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineAbmsCertificationClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: abmsCertificationColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { search: [params.data.name, params.data.status].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultAbmsCertificationData,
        publicData: true,
    }, abmsCertificationSchema);
}
